<div class="prelogin-body">
    <div class="content-width">
        <div class="self-registration-page">
            <div class="row">
                <div class="mx-auto">

                    <div class="card card-signin my-5">
                        <div class="card-body">
                            <div id="selfRegistrationRoot"></div>
                        </div>
                        <div class="margin-bottom-20 margin-top-20 text-center" *ngIf="showLoginPageLink">
                            <a class="link-no-decor" (click)="redirect()">
                                <body-text class="primary-color medium-size">Click here to get back to login page</body-text>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>